<template>
  <el-dialog title="图片裁剪" :append-to-body="true" :visible.sync="visible" width="1000px" @close="closeImageClipping">
    <div class="qm-image-clipping">
      <div class="qm-image-clipping-preview">
        <div class="qm-image-clipping-size">
          <div class="qm-image-clipping-size_content">
            <div
              v-for="item in sizeThanColumn"
              :key="item.type"
              :class="{ 'qm-size-column-active': item.type == currentSize }"
              @click="chooseTheSize(item)"
            >
              <span class="qm-size-column-name">{{ item.size }}</span>
            </div>
          </div>
        </div>
        <div class="qm-operation-btn">
          <el-button type="primary" size="small" @click="pluginExe('cropPicture')">保存</el-button>
        </div>
      </div>
      <div v-if="refresh">
        <ImgCutter
          ref="imgCutterModal"
          :cross-origin="params.crossOrigin"
          :label="params.label"
          :rate="params.rate"
          :index="params.index"
          :is-modal="params.isModal"
          :show-choose-btn="params.showChooseBtn"
          :lock-scroll="params.lockScroll"
          :box-width="params.boxWidth"
          :box-height="params.boxHeight"
          :cut-width="params.cutWidth"
          :cut-height="params.cutHeight"
          :size-change="params.sizeChange"
          :move-able="params.moveAble"
          :img-move="params.imgMove"
          :tool="params.tool"
          :file-type="params.fileType"
          :original-graph="params.originalGraph"
          :preview-mode="params.previewMode"
          :tool-box-overflow="params.toolBoxOverflow"
          :small-to-upload="params.smallToUpload"
          :save-cut-position="params.saveCutPosition"
          :scale-able="params.scaleAble"
          :do-not-display-copyright="true"
          tool-bgc="params.toolBgc"
          @cutDown="cutDown"
        >
          <span v-if="params.isModal == false" slot="choose"></span>
          <span v-if="params.isModal == false" slot="cancel"></span>
          <span v-if="params.isModal == false" slot="confirm"></span>
        </ImgCutter>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import ImgCutter from './img-cutter.vue'

import { uploadImage } from '../api'
export default {
  components: {
    ImgCutter,
  },
  props: {
    imageClippingVisible: {
      type: Boolean,
      default: false,
    },
    imageClippingInfo: {
      type: Object,
      default: () => {},
    },
    categoryId: {
      type: String,
      default: '0',
    },
    storeId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      visible: false, // 弹窗显示隐藏
      params: {
        label: '',
        fileType: 'jpeg',
        crossOrigin: true,
        crossOriginHeader: '*',
        rate: '',
        toolBgc: 'none',
        isModal: false,
        showChooseBtn: false,
        saveCutPosition: true,
        scaleAble: true,
        lockScroll: true,
        toolBoxOverflow: true,
        boxWidth: 720,
        boxHeight: 500,
        cutWidth: 400,
        cutHeight: 400,
        sizeChange: true,
        moveAble: true,
        imgMove: true,
        tool: true,
        originalGraph: false,
        smallToUpload: true,
        previewMode: true,
        index: '',
      },
      imgSrc: '',
      refresh: true,
      sizeThanColumn: [
        { type: 1, size: '自由裁剪', vaule: '' },
        { type: 2, size: '1：1', vaule: '1:1' },
        { type: 3, size: '2：3', vaule: '2:3' },
        { type: 4, size: '3：2', vaule: '3:2' },
        { type: 5, size: '3：4', vaule: '3:4' },
        { type: 6, size: '4：3', vaule: '4:3' },
        { type: 7, size: '9：16', vaule: '9:16' },
        { type: 8, size: '16：9', vaule: '16:9' },
      ],
      currentSize: 1,
      currentTailorSize: null,
    }
  },
  watch: {
    imageClippingVisible(n) {
      this.visible = n
      if (n) {
        this.refresh = true
        const { name, src, fileType } = this.imageClippingInfo
        this.params.fileType = fileType
        this.currentSize = 1
        this.$nextTick(() => {
          this.$refs.imgCutterModal &&
            this.$refs.imgCutterModal.handleOpen({
              name,
              src,
            })
        })
      }
    },
  },
  methods: {
    cutDown(res) {
      this.imgSrc = res.dataURL
      const { dataURL, fileName } = res
      const blob = this.convertBase64UrlToBlob(dataURL)
      const file = new File([blob], fileName, {
        type: '',
        lastModified: Date.now(),
      })
      const formData = {
        category_id: this.categoryId,
        store_id: this.storeId,
        file,
      }
      uploadImage(formData).then(res => {
        if (res) {
          this.$emit('update:imageClippingVisible', false)
          this.$emit('imageCroppingSuccess')
        }
      })
    },
    // 保存图片裁剪
    pluginExe(functionName) {
      this.$refs.imgCutterModal[functionName]()
    },
    /**
     *Base64字符串转二进制
     */
    convertBase64UrlToBlob(urlData) {
      var bytes = window.atob(urlData.split(',')[1]) // 去掉url的头，并转换为byte
      // 处理异常,将ascii码小于0的转换为大于0
      var ab = new window.ArrayBuffer(bytes.length)
      var ia = new window.Uint8Array(ab)
      for (var i = 0; i < bytes.length; i++) {
        ia[i] = bytes.charCodeAt(i)
      }
      return new Blob([ab], {
        type: '',
      })
    },
    // 关闭图片裁剪弹窗
    closeImageClipping() {
      this.refresh = false
      this.$emit('update:imageClippingVisible', false)
    },
    // 选择裁剪的尺寸
    chooseTheSize(item) {
      this.refresh = false
      this.currentTailorSize = item
      const { type, vaule } = item
      this.currentSize = type
      const { name, src, fileType } = this.imageClippingInfo
      this.params.fileType = type > 1 ? fileType : ''
      this.params.rate = vaule
      this.refresh = true
      this.$nextTick(() => {
        this.$refs.imgCutterModal &&
          this.$refs.imgCutterModal.handleOpen({
            name,
            src,
          })
      })
    },
  },
}
</script>
